import { useSuspenseQuery } from "@tanstack/react-query";

import { useApi } from "@/api/client";

import keys from "./keys";
import { BatteryData } from "./types";

export const useOneModuleBatteryDataSuspense = ({
  address,
}: {
  address: number;
}) => {
  const api = useApi();

  return useSuspenseQuery({
    queryKey: keys.one(address),
    queryFn: async (): Promise<BatteryData[]> => {
      const moduleBatteryData = await api.get<{ batteryData: BatteryData[] }>(
        `modules-data/battery-data/${address}`
      );
      const raw = (await moduleBatteryData.json()) as {
        batteryData: BatteryData[];
      };
      return raw.batteryData as BatteryData[];
    },
  });
};
